import {FRAUD_PREVENTION_MAX_POINTS, FRAUD_PREVENTION_MAX_TRANSACTIONS} from "../modals/CampaignBuilderModal";
import {FRAUD_PREVENTION} from "../../pages/SingleCampaign";
import TextInput from "./TextInput";

export const FraudPreventionBuilder = ({missingValue, maxPoints, maxTransactions, onInputChange}) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            <TextInput
                label="Max. points from campaign"
                type="number"
                placeholder="0"
                error={missingValue === FRAUD_PREVENTION_MAX_POINTS ? "Required" : undefined}
                value={maxPoints ?? ""}
                onChange={(event) => onInputChange(FRAUD_PREVENTION_MAX_POINTS, FRAUD_PREVENTION, event.target.value)}
            />
            <TextInput
                label="Max. transactions"
                type="number"
                placeholder="0"
                error={missingValue === FRAUD_PREVENTION_MAX_TRANSACTIONS ? "Required" : undefined}
                value={maxTransactions ?? ""}
                onChange={(event) => onInputChange(FRAUD_PREVENTION_MAX_TRANSACTIONS, FRAUD_PREVENTION, event.target.value)}
            />
        </div>
    );
}
